module.exports = __webpack_public_path__ + "src/assets/img/portrait.8c07ff1a.jpg";